import { syntaxTree } from "@codemirror/language";
import {
  findMarkerPositions,
  decorateHiddenMarkers,
  shouldHideMarkers,
  decorateFallback
} from "../utils/decorationHelper";

export function decoratePairedMarks(node, view, widgets, { markTypeName, mode = "edit" }) {

  if (node.from >= node.to) return false;

  const tree = syntaxTree(view.state);
  const { markStart, markEnd, foundPair } = findMarkerPositions(tree, node.from, node.to, markTypeName);

  if (!foundPair) { return decorateFallback(widgets, node); }
  if (shouldHideMarkers(view, node, mode)) { return decorateHiddenMarkers(widgets, markStart, markEnd); }

  return true;
}
